import {PAYMENT} from "../../../../constants";

export default {
    state: {
        payments: [
            {
                id: 1,
                type: PAYMENT.CASH,
                title: 'Наличными',
                description: 'Покупку можно оплатить в офисе или при доставке курьером.'
            },
            {
                id: 2,
                type: PAYMENT.CASHLESS,
                title: 'По безналу',
                description: 'Менеджер выставит Вам счет реквизитами, который можете оплатить в любом банке',
            },
            {
                id: 3,
                type: PAYMENT.CARD,
                title: 'Картой',
                description: 'Оплата картой производится магазинах СТОМАЛЮКС.'
            },
        ],
        selectedPayment:  {
            id: 1,
            type: PAYMENT.CASH,
            title: 'Наличными',
            description: 'Покупку можно оплатить в офисе или при доставке курьером.'
        },
    },
    getters: {
        getPayments(state) {
            return state.payments
        },
        getPaymentsTypes(state) {
            return state.payments.map(p => p.type)
        },
        getSelectedPayment(state) {
            return state.selectedPayment
        }
    },
    mutations: {
        setSelectedPayment(state, type) {
            state.selectedPayment = state.payments.find(p => p.type === type)
        },
    }
}
